(function() {
  angular
    .module('specsguardApp')
    .directive('sgTableBulkMode', sgTableBulkMode);

    sgTableBulkMode.$inject = [];

  function sgTableBulkMode () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-mat-table/sg-table-bulk-mode/sg-table-bulk-mode.html',
    };
  };
})();
